export const firebaseConfig = {
  apiKey: "AIzaSyAFMmi_fp4UBprEM9kA8o_SL45FJ58Juhc",
  // databaseURL: 'https://jb-chess-default-rtdb.firebaseio.com/',    // RealTime DB
  authDomain: "jb-chess.firebaseapp.com",
  projectId: "jb-chess",
  storageBucket: "jb-chess.appspot.com",
  messagingSenderId: "230963432377",
  appId: "1:230963432377:web:c26e6ad8a28380d0d70468"
};
